import React, { createContext, PropsWithChildren, useCallback, useContext, useRef, useState } from 'react';

interface FreeTrialFormContextData {
  isSubmitted: boolean;
  markAsSubmitted(): void;
  setPendingEmail(email: string): void;
  consumePendingEmail(): string;
}

const FreeTrialFormContext = createContext<FreeTrialFormContextData>({} as FreeTrialFormContextData);

const FreeTrialFormProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const pendingEmailRef = useRef<string>('');

  const markAsSubmitted = useCallback(() => {
    setIsSubmitted(true);
  }, []);

  const setPendingEmail = useCallback((email: string) => {
    pendingEmailRef.current = email;
  }, []);

  const consumePendingEmail = useCallback(() => {
    const email = pendingEmailRef.current;
    pendingEmailRef.current = '';
    return email;
  }, []);

  return (
    <FreeTrialFormContext.Provider
      value={{
        isSubmitted,
        markAsSubmitted,
        setPendingEmail,
        consumePendingEmail,
      }}
    >
      {children}
    </FreeTrialFormContext.Provider>
  );
};

const useFreeTrialFormContext = (): FreeTrialFormContextData => {
  const context = useContext(FreeTrialFormContext);

  if (!context) {
    throw new Error('useFreeTrialFormContext must be used within a FreeTrialFormProvider');
  }

  return context;
};

export { useFreeTrialFormContext, FreeTrialFormProvider };
